import { render, staticRenderFns } from "./Type3c.vue?vue&type=template&id=6971ad54&"
import script from "./Type3c.vue?vue&type=script&lang=js&"
export * from "./Type3c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports